import { render, staticRenderFns } from "./RepoIssues.vue?vue&type=template&id=a2a931a0&"
import script from "./RepoIssues.vue?vue&type=script&lang=js&"
export * from "./RepoIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports